import { SpaceBetween, tk, Typography } from '@sunwebgroup/ui-components'
import React from 'react'
import { styled } from 'styled-components'

const RatingBubble = styled.div`
  padding: ${tk('spacing_2xs')} ${tk('spacing_sm')};
  background-color: ${tk('theme_color_neutral_300')};
  margin-right: ${tk('spacing_sm')};
  border-radius: ${tk('radius_extra_large')};
`

interface ReviewScoreProps {
  rating: string
  scoreLabel: string
}

export function ReviewScore({ rating, scoreLabel }: ReviewScoreProps) {
  return (
    <SpaceBetween direction="x" alignItems="center">
      <RatingBubble>
        <Typography $variant="body-md-bold">{rating}</Typography>
      </RatingBubble>
      <Typography $variant="body-sm-bold">{scoreLabel}</Typography>
    </SpaceBetween>
  )
}
